var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5534 17.8094L27.465 19.8466L27.4371 19.9024L30.2139 21.9396L28.7348 26.5163L24.5906 28.5675L27.0743 20.9349H18.2278L19.079 18.2838H27.9255L29.0976 14.6559H7.03711L11.3766 11.4326H30.1441L32.9627 13.4838L31.5534 17.8094Z",
    fill: "#FCFC03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8278 17.335L13.2743 25.2884H25.6576L24.5906 28.5675L8.73938 28.5675L12.9952 15.2141L15.8278 17.335Z",
    fill: "#FCFC03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlast);
export default __webpack_public_path__ + "static/media/blast.cab324d1cb87d895d89ed317a122997a.svg";
export { ForwardRef as ReactComponent };